import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const GreatSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#A1A1A1"
      fillRule="evenodd"
      d="M15.3 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm1.5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-11.5.975h-.625V9.6c0 1.875 1.935 3.264 4.123 3.264 2.19 0 4.127-1.38 4.127-3.264v-.625H5.3Zm3.498 2.639c-1.404 0-2.36-.666-2.717-1.389h5.439c-.356.725-1.312 1.389-2.722 1.389Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF990A"
      fillRule="evenodd"
      d="M6.953 4.92 6.175 3.5l-.778 1.42L3.8 5.22l1.116 1.176L4.707 8l1.468-.694L7.643 8l-.21-1.605L8.55 5.219 6.953 4.92Zm5.25 0-.778-1.42-.778 1.42-1.597.299 1.116 1.176L9.957 8l1.468-.694L12.893 8l-.21-1.605L13.8 5.219l-1.597-.298Z"
      clipRule="evenodd"
    />
  </svg>
)
export default GreatSVG
